const RewardStatuses = {
  REWARD_FOR_CONFIRMATION: '0',
  REWARD_SUCCESS: '1',
  REWARD_DECLINED: '2'
};

RewardStatuses.install = function (Vue) {
    Vue.prototype.$getConstRewardStatus = (key) => {
        return RewardStatuses[key];
    }
}

export default RewardStatuses;
